import React from 'react';
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";
import OurStoryImg from '../../assets/img/ourStoryImg.png'
import {CardTitle, P2} from "../Kit/Kit";
import storyBG from '../../assets/img/storyBG.jpg';

const StyledContainer = BodyContainer.extend`
  @media(min-width: 768px) {
  background: url(${storyBG}) no-repeat right;
  background-size: contain;
  }
`;

const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 18px;
  align-items: center;
  grid-template-areas: 
        'img' 
        'title'
        'story';
  
  @media(min-width: 768px) {
      grid-template-columns: 3fr 2fr;
      grid-template-areas: 
        'title .' 
        'story img';
      grid-column-gap: 36px;
  }
`;

const StoryHeader = CardTitle.extend`
  grid-area: title;
  text-align: left;
`;

const StoryText = styled.div`
  grid-area: story;
  align-self: start;
  text-align: left;
  
  p{
    text-align: left;
    margin-bottom: 20px;
  }
`;

const StoryImg = styled.img`
  grid-area: img;
  width: 100%;
  height: auto;
  order: 1;
  
  @media(min-width: 768px) {
    order: 2;
    align-self: start;
  }
`;

export const AnchorPoint = styled.div`
  margin-top: -60px; 
  padding-top: 60px; 
  -webkit-background-clip: content-box;
  background-clip: content-box;
  
  @media(min-width: 768px) {
   margin-top: -100px; 
   padding-top: 100px; 
  }
`;

const OurStory = (props) => {
    const {title, content} = props.data;
    return (
      <StyledContainer>
          <AnchorPoint id={'ourstory'}/>
          <InnerContainer>
              <StoryHeader
                dangerouslySetInnerHTML={{__html: title}}
              />
              <StoryText>
                  <P2
                    dangerouslySetInnerHTML={{__html: content}}
                  />
              </StoryText>
              <StoryImg src={OurStoryImg} alt="H & N Fish Co. Distribution center San Francisco"/>
          </InnerContainer>
      </StyledContainer>
    );
};

export default OurStory;



// WEBPACK FOOTER //
// ./src/components/GetToKnow/OurStory.js